(function() {
    'use strict';

    angular
        .module('gatewayApp')
         .service("workflowSharedService", function () {        	
        	this.viewFrom= 'exposureType'
        })
        
        .controller('ExposureTypeController', ExposureTypeController);

    ExposureTypeController.$inject = ['$scope', '$state','$rootScope','ExposureType', 'GlobalValues', 'workflowSharedService', 
    'EntityPermissions', 'ScreenLog', 'entityConstants', '$timeout', 'IntradayMarket', 'MessageBox', 'validateSODAndSession','Auth'];

    function ExposureTypeController($scope, $state,$rootScope, ExposureType, GlobalValues, workflowSharedService, 
      EntityPermissions, ScreenLog, entityConstants, $timeout, IntradayMarket, MessageBox, validateSODAndSession,Auth) {
        var vm = this;
        vm.globalValues = GlobalValues;
        vm.entityConstants = entityConstants;
        vm.screenName = entityConstants.ENTITY_SHORT_NAME.EXPOSURE_TYPE;
        $scope.noOfRecordsPerPage = GlobalValues.getNoOfRecordsPerPageInPagination();
        $scope.page = 1;
        vm.screenLog = ScreenLog;
        workflowSharedService.viewFrom = "exposureType";
        $scope.refresh=refresh;
        vm.validateSODAndSession = validateSODAndSession;
        
        vm.launch=launch;
        vm.editExposureType=editExposureType;
        function launch() {
          if(vm.marketSessionSettings.sessionStatus=='OPEN'){
            MessageBox.openMessageBox("Alert", "Addition/Modification is permitted only after the IB.SPOT market hours...!", "Ok", "exposuretype");
          }else if(!vm.validateSODAndSession.allowToAddOrEdit){
        	  MessageBox.openMessageBox("Alert", "SOD is completed for the business day, addition/modifications is not permitted.", "Ok", "exposuretype");
          }else{
            $state.go("exposure-type-new");
          }
        }

        function editExposureType(exposureTypeId){
          if(vm.marketSessionSettings.sessionStatus=='OPEN'){
            MessageBox.openMessageBox("Alert", "Addition/Modification is permitted only after the IB.SPOT market hours...!", "Ok", "exposuretype");
          }else if(!vm.validateSODAndSession.allowToAddOrEdit){
        	  MessageBox.openMessageBox("Alert", "SOD is completed for the business day, addition/modifications is not permitted.", "Ok", "exposuretype");
          }else{
            vm.screenLog.screenLog(vm.screenName, exposureTypeId, vm.entityConstants.ENTITY_ACTION_TYPE.EDIT);
            $state.go("exposure-type-edit", {id:exposureTypeId});
          }
        }
        
        vm.permitExposureTypeAddEntityAction = EntityPermissions.hasPermission('ExposureType.CREATE');
        vm.permitExposureTypeEditEntityAction = EntityPermissions.hasPermission('ExposureType.EDIT');
        vm.permitExposureTypeViewEntityAction = EntityPermissions.hasPermission('ExposureType.VIEW');
       /* if(vm.permitExposureTypeViewEntityAction ==false){
          //message box 
          MessageBox.openMessageBox('Alert', 'Session expired. You will be redirected to login page...!', 'Ok', 'permitExposureTypeViewEntityAction');
        }
    
        $rootScope.$on('gatewayApp.messagebox.ok.permitExposureTypeViewEntityAction', function (event) {
          Auth.sessionlogout();
        });
        
        $rootScope.$on('gatewayApp.messagebox.clear.permitExposureTypeViewEntityAction', function (result){
          Auth.sessionlogout();
        })*/
        
        logScreenAccess();
        loadAll();

       function loadAll() {
    	   
    	   ExposureType.getAllExposureTypes(function(result) {
               vm.exposureTypes = result;                
           });
    	 
        }      
       
        //get market session settings.
        IntradayMarket.getIntradayMarketSessionSettingsForInstrument({"instrument":'InterbankSPOT'}, onGetMarketSessionSuccess, onGetMarketSessionFailure);

        function onGetMarketSessionSuccess(result){
          vm.marketSessionSettings = result;
        }

        function onGetMarketSessionFailure(){

        }

       function logScreenAccess(){
    	   ScreenLog.screenLog(vm.screenName,0, entityConstants.ENTITY_ACTION_TYPE.ACCESS);
       }
       
       $scope.toggle = true;
       function refresh() {
           $scope.toggle = false;
           $scope.refreshFlag = false;
           loadAll();
           if ($scope.toggle == false) {
               $timeout(function() {
                   $scope.toggle = true;
               }, 2000);
               $scope.refreshFlag = false;
           }
       };
    }
})();
